import HttpEntityClient from '@123/druid/dist/Components/Http/HttpEntityClient';
import {type Recommendation, recommendationSchema} from '@Component/Recommendation/Schema/RecommendationSchema';

export default class RecommendationService {
    private readonly alternativeUrl = '/product/alternative/';

    constructor(private entityClient: HttpEntityClient = new HttpEntityClient()) {}

    public getAlternativeRecommendation(productId: number): Promise<Recommendation> {
        return this.entityClient.get(this.alternativeUrl + productId, recommendationSchema);
    }
}
